export default __webpack_public_path__ + "media/BRONZE PACKAGE.e21cf2fc622d565b3308459be9fe7cbd.mp4";